import React from 'react'
import { Footer } from '../components/Footer';
import { Link } from 'react-router-dom';

export const ProductList = ({products, cartTotals, setCartTotals, setCartContents, cartContents}) => {

    const handleAddToCart = (id) => {

        const product = products.find( (product) => product.id === id  );
        
        setCartTotals(Number(cartTotals) + Number(product.price));

        const addProduct = {
            id: new Date().getTime().toString(),    
            name: product.name,
            price: product.price,
            img: product.img    
        }
    
        setCartContents([...cartContents, addProduct]);

        let getAddToCart = document.getElementById(id);

        getAddToCart.textContent = 'Adding to cart...';

        setTimeout( ()=> {
            getAddToCart.textContent = 'Add to cart';
        }, 500 )

    }

    return (
    <>

<div className="p-6 bg-slate-300"></div>

    
<div className='flex justify-center bg-black items-center mt-100 h-48'>
    <h1 className='text-white'>Products</h1>
    </div>

<div className="flex flex-row flex-wrap gap-4 mt-20 mx-auto justify-center">
        
    
    
    {products.map((product) => (

<div key={product.id}  className="md:max-w-sm w-full flex items-center  bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700">
    <Link to={`/product/${product.id}`}>
        <img className="rounded-t-lg" src={`${product.img}`} alt={product.name} width="200px" />
    </Link>
    <div className="p-5">
        <a href="/">
            <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">{product.name}</h5>
        </a>
        <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">Short Description will go here.</p>
        <p>Price €{product.price}</p>
      
        <p className="m-1 inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-red-700 rounded-lg hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 cursor-pointer"><Link to={`/product/${product.id}`}>Read More</Link></p>
      
        <p onClick={()=> handleAddToCart(product.id)} className="m-1 inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 cursor-pointer" id={product.id}>
            Add to cart
        </p>

      
    </div>
</div>
    )

    )}

</div>

      <Footer />
    </>
  )
}
